
import animeData from '~/static/lottiefiles/circle.json'
import cardsData from '~/static/lottiefiles/cards.json'

export default {
  name: 'LoyaltyPage',

  async asyncData({ app, env, $axios }) {
    const response = await $axios.$post(`${env.API_URL_SITE}/seo`, {
      url: '/loyalty',
      project: "korzinka.uz"
    })

    const currentLocale = app.i18n.locale;

    return { seo: response?.data?.items, faq: response?.data?.items?.[currentLocale]?.[0]?.QNA || null }
  },

  data() {
    return {
      accordionHeights: [],
      answers: [],

      seo: null,
      faq: null,

      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        variableWidth: true,
        speed: 250,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      },

      prevIconLottiefile: null,
      nextIconLottiefile: null,

      checkerDevice: '',

      // QNA: {},
      getCards: {},
      cardBlock: {},
      speedPoints: {},
      cashback: {},

      isDevice: ''
    }
  },


  head() {
    const scripts = [];
    const noscripts = [];
    if(this?.faq.length) {
      scripts.push({
        hid: 'ldjson-schema',
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": this.faq.map(item => ({
            "@type": "Question",
            "name": item.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": item.answer
            }
          }))
        }
      })
    }

    /* YA metrika */
    scripts.push({
        hid: 'yandex-metrika',
        innerHTML: `(  (function(m,e,t,r,i,k,a){
          m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();
          for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
          k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
      })(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=103512154', 'ym');

      ym(103512154, 'init', {ssr:true, webvisor:true, clickmap:true, ecommerce:"dataLayer", accurateTrackBounce:true, trackLinks:true});`
    });

    noscripts.push({
        hid: 'yandex-noscript',
        innerHTML: `<div><img src="https://mc.yandex.ru/watch/103512154" style="position:absolute; left:-9999px;" alt="" /></div>`
    });
    return {
      title: this.seo[this.$i18n.locale][0].title,
      meta: [
        { hid: 'og:type', property: 'og:type', content: 'website' },
        {
          hid: 'description',
          name: 'description',
          content: this.seo[this.$i18n.locale][0].description
        },
        {
          hid: 'og-title',
          property: 'og:title',
          content: this.seo[this.$i18n.locale][0].og_title
        },
        {
          hid: 'og-description',
          property: 'og:description',
          content: this.seo[this.$i18n.locale][0].og_description
        },
        {
          hid: 'og-url',
          property: 'og:url',
          content: this.seo[this.$i18n.locale][0].og_url
        },

        {
          hid: 'og-image',
          property: 'og:image',
          content: this.seo[this.$i18n.locale][0].og_img
        },
        {
          property: 'twitter:card',
          content: 'summary_large_image'
        }
      ],

      link: [
        {
          rel: 'canonical',
          href: `https://korzinka.uz/${
            this.$i18n.locale === 'ru' ? '' : this.$i18n.locale + '/'
          }loyalty`
        },
        {
          rel: 'alternate',
          href: `https://korzinka.uz/loyalty`,
          hreflang: 'ru'
        },
        {
          rel: 'alternate',
          href: `https://korzinka.uz/uz/loyalty`,
          hreflang: 'uz'
        },
        {
          rel: 'alternate',
          href: `https://korzinka.uz/en/loyalty`,
          hreflang: 'en'
        }
      ],
      script: [...scripts],
      noscript: [...noscripts]
    }
  },

  async mounted() {
    await this.fetchDatas()

    // try {
    //   const { items } = await fetchMetaTags('/loyalty')
    //   this.seo = items[this.$i18n.locale][0]
    // } catch (error) {
    //   console.log(error)
    // }

    this.customizeForDevice()

    this.initLottieFiles()

    this.cardsAnimation()

    this.initScrollMagic()
  },

  methods: {
    async fetchDatas() {
      try {

        const getCards = await this.$axios.$get(
          `${process.env.API_URL_SITE}/how_get_card`
        )
        const speedPoints = await this.$axios.$get(
          `${process.env.API_URL_SITE}/loyalty_four`
        )
        const cardBlock = await this.$axios.$get(
          `${process.env.API_URL_SITE}/loyalty_three`
        )

        const cashback = await this.$axios.$get(
          `${process.env.API_URL_SITE}/loyalty_one`
        )

        this.getCards = getCards.data
        this.cardBlock = cardBlock.data
        this.speedPoints = speedPoints.data
        this.cashback = cashback.data
      } catch (e) {}
    },

    setConfigAccordion() {
      const answers = document.querySelectorAll(
        '.loyalty-page__accordion-answer'
      )
      answers.forEach((a) => this.answers.push(a))

      answers.forEach((h) => {
        this.accordionHeights.push(h.offsetHeight + 36)
        h.style.height = `0px`
      })

      this.answers[0].parentNode.classList.add('active')
      this.answers[0].style.height = `${this.accordionHeights[0]}px`
    },

    initLottieFiles() {
      this.prevIconLottiefile = window.lottie.loadAnimation({
        container: this.$refs.cprev,
        loop: false,
        autoplay: false,
        animationData: animeData
      })

      this.nextIconLottiefile = window.lottie.loadAnimation({
        container: this.$refs.cnext,
        loop: false,
        autoplay: false,
        animationData: animeData
      })

      window.lottie.loadAnimation({
        name: 'cardsData',
        container: this.$refs.cardsData,
        loop: false,
        autoplay: false,
        animationData: cardsData
      })

      window.lottie.loadAnimation({
        name: 'mobileLevitate',
        container: this.$refs.ml,
        loop: true,
        autoplay: true,
        path: `/lottiefiles/levitate/mobile-levitate-${this.$i18n.locale}.json`
      })
    },

    initScrollMagic() {
      const browserSize = window.innerWidth

      const ctrl = new window.ScrollMagic.Controller()

      const info = document.querySelector('.get-points__info')
      const items = document.querySelectorAll('.get-points__list-item')
      const totalSteps = items.length

      const scrollPixelsPerStep = browserSize > 578 ? 900 : 360
      const dur = scrollPixelsPerStep * totalSteps;
      const mobileAddScrollPx = window.innerWidth < 576 ? 1000 : 0
      const totalDuration = dur + mobileAddScrollPx

      let swipePx
      if (window.innerWidth >= 1600) {
        swipePx = 400
      } else if (window.innerWidth < 576) {
        swipePx = 250
      } else {
        swipePx = 300
      }

      // Создаем сцену ScrollMagic
      const scene = new window.ScrollMagic.Scene({
        triggerElement: this.$refs.points,
        triggerHook: 0,
        duration: totalDuration
      })
        .setPin(this.$refs.points)
        .addTo(ctrl)

      // Привязываем анимацию к прогрессу сцены (от 0 до 1)
      scene.on('progress', (event) => {
        const progress = event.progress // Значение от 0.0 до 1.0

        // Вычисляем текущий шаг (индекс от 0 до 4)
        // progress * totalSteps даст число от 0 до 5. Используем Math.min, чтобы не выйти за рамки массива.
        let activeIndex = Math.floor(progress * totalSteps)
        if (activeIndex >= totalSteps) {
          activeIndex = totalSteps - 1
        }

        // 1. Переключаем активный класс у элементов списка
        items.forEach((item, index) => {
          if (index === activeIndex) {
            item.classList.add('active')
          } else {
            item.classList.remove('active')
          }
        })

        // 2. Смещаем блок с текстом на нужную высоту
        // activeIndex + 1 соответствует твоему "counter" из старого кода
        const counter = activeIndex + 1
        info.style.transform = `translateY(${-swipePx * counter}px)`
      })
    },

    accordionToggler(e) {
      const id = e.target.getAttribute('data-id')

      this.accordionHeights.forEach((h, idx) => {
        if (Number(id) === idx + 1) {
          if (!this.answers[idx].parentNode.classList.contains('active')) {
            this.answers.forEach((i) => {
              i.parentNode.classList.remove('active')
              i.style.height = `0px`
            })

            this.answers[idx].parentNode.classList.add('active')
            this.answers[idx].style.height = `${h}px`
          } else {
            this.answers[idx].parentNode.classList.remove('active')
            this.answers[idx].style.height = `0px`
          }
        }
      })
    },

    slideToNext() {
      this.$refs.vsc.next()
    },
    slideToPrev() {
      this.$refs.vsc.prev()
    },

    cardsAnimation() {
      window.lottie.setDirection(1)
      window.lottie.play('cardsData')
    },

    // Lottie files
    startPrevIconLottiefile() {
      this.prevIconLottiefile.setDirection(1)
      this.prevIconLottiefile.play()
    },

    endPrevIconLottiefile() {
      this.prevIconLottiefile.setDirection(-1)
      this.prevIconLottiefile.play()
    },

    startNextIconLottiefile() {
      this.nextIconLottiefile.setDirection(1)
      this.nextIconLottiefile.play()
    },

    endNextIconLottiefile() {
      this.nextIconLottiefile.setDirection(-1)
      this.nextIconLottiefile.play()
    },

    customizeForDevice() {
      const ua = navigator.userAgent
      const checker = {
        iphone: ua.match(/(iPhone|iPod|iPad)/),
        android: ua.match(/Android/)
      }
      if (checker.iphone) {
        this.checkerDevice = `${process.env.APPSTORE_URI}`
        this.isDevice = 'ios'
      } else if (checker.android) {
        this.checkerDevice = `${process.env.GOOGLEPLAY_URI}`
        this.isDevice = 'android'
      } else {
        this.checkerDevice = `https://korzinka.uz/app/${this.$i18n.locale}`
      }
    }
  }
}
